const fontList = [
  {
    fileName: '/fonts/NotoSans-Regular.woff2',
    type: 'woff2',
    prefetch: false
  },
  {
    fileName: '/fonts/untitled-sans-web-black.woff',
    type: 'woff',
    prefetch: false
  },
  {
    fileName: '/fonts/untitled-sans-web-bold.woff',
    type: 'woff',
    prefetch: true
  },
  {
    fileName: '/fonts/untitled-sans-web-medium.woff',
    type: 'woff',
    prefetch: false
  },
  {
    fileName: '/fonts/untitled-sans-web-regular.woff',
    type: 'woff',
    prefetch: true
  },
  {
    fileName: '/fonts/Antonio-VariableFont_wght.woff',
    type: 'woff',
    prefetch: true
  }
]

const fontFace = `
    @font-face {
      font-family: 'Untitled Sans';
      font-style: normal;
      font-weight: normal;
      font-display: swap;
      src: url(/fonts/untitled-sans-web-regular.woff) format('woff');
    }
    @font-face {
      font-family: 'Untitled Sans Medium';
      font-style: normal;
      font-weight: normal;
      font-display: swap;
      src: url(/fonts/untitled-sans-web-medium.woff) format('woff');
    }
    @font-face {
      font-family: 'Untitled Sans Bold';
      font-style: normal;
      font-weight: normal;
      font-display: swap;
      src: url(/fonts/untitled-sans-web-bold.woff) format('woff');
    }
    @font-face {
      font-family: 'Untitled Sans Black';
      font-style: normal;
      font-weight: normal;
      font-display: swap;
      src: url(/fonts/untitled-sans-web-black.woff) format('woff');
    }
    @font-face {
      font-display: swap; 
      font-family: 'NotoSans Regular';
      font-style: normal;
      font-weight: 400; 
      src: url(/fonts/NotoSans-Regular.woff2) format('woff2');
    }
    @font-face {
      font-display: swap; 
      font-family: 'Antonio';
      font-style: normal;
      font-weight: 400;
      src: url(/fonts/Antonio-VariableFont_wght.woff) format('woff');
    }
  `

export { fontList }
export default fontFace
